import React from 'react';
import './StationHoverCard.css';

const StationHoverCard = React.forwardRef(({ station, onClose, onImageZoom, lineColor = '#F18401' }, ref) => {
  const isBranch = station.isBranch || false;
  
  const handleImageClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (onImageZoom && station.img) {
      onImageZoom({ src: station.img, alt: station.name });
    }
  };

  const handleImageTouch = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (onImageZoom && station.img) {
      onImageZoom({ src: station.img, alt: station.name });
    }
  };
  
  const handleCardClose = (e) => {
    e.stopPropagation();
    if (onClose) onClose();
  };
  
  return (
      <div className={`station-hover-card ${isBranch ? 'branch-hover-card branch-click-card' : ''}`} ref={ref}>
        {/* Close button for branch cards */}
        {isBranch && onClose && (
          <button 
            className="card-close-button"
            onClick={handleCardClose}
            aria-label="Close"
          >
            ×
          </button>
        )}
        
        {/* Branch stations show large image first */}
        {isBranch && station.img && (
          <div 
            className="branch-project-image"
            onClick={handleImageClick}
            onTouchEnd={handleImageTouch}
          >
            <img 
              src={station.img} 
              alt={station.name}
              onClick={handleImageClick}
              onTouchEnd={handleImageTouch}
              style={{ pointerEvents: 'auto' }}
            />
          </div>
        )}
      
      <div className="hover-card-header" style={{ borderBottomColor: lineColor }}>
        {/* Main stations show small icon */}
        {!isBranch && station.icon && (
          <div className="company-icon">
            <img style={{width: '48px', height: '48px'}} src={station.icon} alt={station.name} />
          </div>
        )}
        <div className="hover-card-title">
          <h3 className="hover-card-company-name">{station.name}</h3>
          {station.timeFrame && <p className="hover-card-timeframe">{station.timeFrame}</p>}
        </div>
      </div>
      
      {/* Show positions if they exist (main stations only) */}
      {station.positions && station.positions.length > 0 && (
        <div className="hover-card-positions">
          {station.positions.map((position, idx) => (
            <div key={idx} className="hover-card-position">
              <p className="position-title">{position.title}</p>
              <p className="position-timeframe">{position.timeFrame}</p>
            </div>
          ))}
        </div>
      )}
      
      {/* Show details if they exist */}
      {station.details && (
        <div className="hover-card-details">
          {station.details}
        </div>
      )}
    </div>
  );
});

StationHoverCard.displayName = 'StationHoverCard';

export default StationHoverCard;

